import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
// Chrome 73 breaks wheel events.
// url: https://github.com/facebook/react/issues/14856
//
function forceSetPassiveEvents() {
  var PASSIVE_EVENTS = ['touchstart', 'touchmove', 'touchend', 'touchcancel', 'wheel'];

  var checkType = function checkType(type, options) {
    if (!PASSIVE_EVENTS.includes(type)) return null;
    var modOptions = {
      "boolean": {
        capture: options,
        passive: false
      },
      object: _objectSpread(_objectSpread({}, options), {}, {
        passive: false
      })
    };
    return modOptions[_typeof(options)];
  };

  var addEventListener = document.addEventListener.bind();

  document.addEventListener = function (type, listener, options, wantsUntrusted) {
    return addEventListener(type, listener, checkType(type, options) || options, wantsUntrusted);
  };

  var removeEventListener = document.removeEventListener.bind();

  document.removeEventListener = function (type, listener, options) {
    return removeEventListener(type, listener, checkType(type, options) || options);
  };
}

export default {
  forceSetPassiveEvents: forceSetPassiveEvents
};